import axios from "axios";

// Define uma instância do Axios com a baseURL da API
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "'https://api.futebotfc.com.br'",
});

// Interceptar respostas para detectar token inválido
api.interceptors.response.use(
  (response) => response, // Retorna a resposta se não houver erros
  (error) => {
    if (error.response?.status === 401) { // Verifica erro de autorização
      localStorage.removeItem("authToken"); // Remove token inválido
      window.location.href = "/login"; // Redireciona para a tela de login
    }
    return Promise.reject(error); // Retorna o erro para ser tratado onde foi chamado
  }
);

export default api;
